var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.2 45.2",
    style: {
      enableBackground: "new 0 0 45.2 45.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED1E79;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,15.9v-1.7c0-1.9-1.6-3.5-3.5-3.5h-2.8c-1.9,0-3.5,1.6-3.5,3.5v4.7H13.3v-4.7c0-1.9-1.6-3.5-3.5-3.5H7.1 c-1.9,0-3.5,1.6-3.5,3.5v1.7c-2,0-3.6,1.6-3.6,3.6v6.2c0,2,1.7,3.6,3.6,3.6V31c0,1.9,1.6,3.5,3.5,3.5h2.8c1.9,0,3.5-1.6,3.5-3.5 v-4.7h18.5V31c0,1.9,1.6,3.5,3.5,3.5h2.8c1.9,0,3.5-1.6,3.5-3.5v-1.7c2,0,3.6-1.6,3.6-3.6v-6.2C45.2,17.5,43.5,15.9,41.6,15.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.000ffae8145eb9e3b4d30f5551e2228c.svg";
export { ForwardRef as ReactComponent };